import { useCallback, useState } from 'react';

/** Estado + helpers para mostrar {@link SistemaToast}. */
export function useSistemaToast(initialMessage = '') {
  const [show, setShow] = useState(false);
  const [message, setMessage] = useState(initialMessage);

  const notify = useCallback((text) => {
    setMessage(text);
    setShow(true);
  }, []);

  const hide = useCallback(() => setShow(false), []);

  return { show, message, setShow, setMessage, notify, hide };
}
